import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

export const getUsersByCompanyId = (companyID, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GETUSER_BY_COMPANYID}?companyId=${companyID}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getSalutations = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_SALUTATIONS, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getContactStatuses = (header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(url.GET_CONTACT_STATUSES, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const saveContact = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.SAVE_CONTACT, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getContactById = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return getApi
      .get(`${url.GET_CONTACT_BY_ID}${payload}`, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
